import { render, staticRenderFns } from "./the-header.vue?vue&type=template&id=34f7bca0&scoped=true"
import script from "./the-header.vue?vue&type=script&lang=js"
export * from "./the-header.vue?vue&type=script&lang=js"
import style0 from "./the-header.vue?vue&type=style&index=0&id=34f7bca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f7bca0",
  null
  
)

export default component.exports